var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5H10.6641C11.081 0.500135 11.479 0.673961 11.7627 0.979492L13.8838 3.26367L15.3848 4.87988C15.6423 5.15724 15.786 5.52191 15.7861 5.90039V17C15.7861 17.8283 15.1144 18.4998 14.2861 18.5H2C1.17157 18.5 0.5 17.8284 0.5 17V2L0.507812 1.84668C0.58461 1.09028 1.22334 0.5 2 0.5Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8572 0V4.42857C10.8572 4.98086 11.3049 5.42857 11.8572 5.42857H16.2857",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49638 5.07497C8.30111 4.8797 7.98453 4.8797 7.78927 5.07497L4.60729 8.25695C4.41203 8.45221 4.41203 8.76879 4.60729 8.96405C4.80255 9.15932 5.11913 9.15932 5.3144 8.96405L8.14282 6.13563L10.9712 8.96405C11.1665 9.15932 11.4831 9.15932 11.6784 8.96405C11.8736 8.76879 11.8736 8.45221 11.6784 8.25695L8.49638 5.07497ZM8.14282 12.2142L8.64282 12.2142L8.64282 5.42852L8.14282 5.42852L7.64282 5.42852L7.64282 12.2142L8.14282 12.2142Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07153 12.2142V14.4285C4.07153 14.7047 4.29539 14.9285 4.57153 14.9285H11.7144C11.9905 14.9285 12.2144 14.7047 12.2144 14.4285V12.2142",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.ba7193581a6ec6b92500cc0f9e9542c0.svg";
export { ForwardRef as ReactComponent };